// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"933":"4d7014d9","3655":"d2ca1a05"}[chunkId] + ".css";
};